import {
    apiRequest,
    komponenPenilaianCreate, 
    komponenPenilaianUpdate,
    komponenPenilaianEmployeeList,
    komponenPenilaianCriteriaList
} from "../../../../../../services/adapters/master/komponenPenilaianService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", komponenPenilaianCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", komponenPenilaianUpdate, {
            body: query
        }, true)
    }
    
    fetchEmployeeList = async (query, cancelToken) => {
        return await apiRequest("get", komponenPenilaianEmployeeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchCriteriaList = async (query, cancelToken) => {
        return await apiRequest("get", komponenPenilaianCriteriaList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default CreateRepository